module.exports = __webpack_public_path__ + "static/media/KC.145b0d0f.svg";